class WebStories extends HTMLElement {
  constructor() {
    super();
    this.video = null;
    this.currentIndex = 0;
    this.sectionId = this.getAttribute("data-slide");
    this.numberVideos = parseInt(this.getAttribute("data-count"));

    this.videos = this.querySelectorAll("video");

    console.log(this.getAttribute("data-format"));

    if (this.getAttribute("data-format") === "stories") {
      new Splide(".splide-videos-list--" + this.getAttribute("data-slide"), {
        perPage: 6,
        pagination: false,
        arrows: this.numberVideos > 5,
        perMove: 1,
        drag: true,
        breakpoints: {
          1100: {
            perPage: 4,
            arrows: this.numberVideos > 4,
          },
          900: {
            perPage: 3,
            arrows: this.numberVideos > 3,
          },
          750: {
            perPage: 6,
            arrows: this.numberVideos > 6,
          },
          650: {
            perPage: 5,
            arrows: this.numberVideos > 5,
          },
          590: {
            perPage: 4,
            arrows: this.numberVideos > 4,
          },
          390: {
            perPage: 3,
            arrows: this.numberVideos > 3,
          },
        },
      }).mount();
    } else {
      new Splide(".splide-videos-list--" + this.getAttribute("data-slide"), {
        perPage: 4,
        pagination: true,
        arrows: true,
        perMove: 1,
        padding: {
          right: 200,
        },
        drag: true,
        type: "loop",
        breakpoints: {
          1100: {
            perPage: 3,
          },
          900: {
            perPage: 2,
          },
          500: {
            perPage: 1,
          },
        },
      }).mount();
    }
    this.slider = new Splide(
      ".splide-videos-list-zoom--" + this.getAttribute("data-slide"),
      {
        drag: true,
        perPage: 1,
        pagination: true,
        arrows: true,
        perMove: 1,
      }
    ).mount();

    this.slider.on("move", (index) => {
      console.log(index);
      this.currentIndex = index;

      this.video = this.querySelector(
        `.video-${this.sectionId}-${this.currentIndex}`
      );

      this.videos.forEach((video) => {
        video.pause();
        video.muted = true;
      });

      this.video.muted = false;
      this.video.play();
    });

    this.close = this.querySelector(".button-close");

    this.close.addEventListener("click", (e) => {
      e.preventDefault();
      this.closeVideosSlider();
    });

    this.querySelectorAll(".splide-video").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openVideosSlider(btn);
      });
    });

    this.sliderVideos = this.querySelector(".splide-videos-list-zoom");

    this.videos.forEach((video) => {
      this.listernerVideo(video);
    });

    this.announcementBar = document.querySelector(
      ".shopify-section-group-header-group"
    );

    this.headerGroup = document.querySelector(
      ".section-header.shopify-section-group-header-group"
    );
    this.body = document.body;
    this.originalBodyOverflow = "";
  }

  openVideosSlider(btn) {
    const newIndex = parseInt(btn.dataset.index);

    if (
      this.sliderVideos.classList.contains("active") &&
      this.currentIndex === newIndex
    ) {
      // If the slider is already open and we click on the same video
      this.video.currentTime = 0; // Reset the video to the beginning
      this.video.play();
    } else {
      this.currentIndex = newIndex;
      this.sliderVideos.classList.add("active");
      this.slider.go(this.currentIndex);
      this.video = this.querySelector(
        `.video-${this.sectionId}-${this.currentIndex}`
      );

      this.videos.forEach((video) => {
        video.pause();
        video.muted = true;
      });

      this.video.muted = false;
      this.video.play();

      // Remove the z-index from the header
      if (this.headerGroup) {
        this.headerGroup.style.zIndex = "auto";
      }

      // Remove the z-index from the announcement bar
      if (this.announcementBar) {
        this.announcementBar.style.zIndex = "auto";
      }

      // Prevent scrolling
      this.originalBodyOverflow = this.body.style.overflow;
      this.body.style.overflow = "hidden";
    }
  }

  closeVideosSlider() {
    this.sliderVideos.classList.remove("active");
    this.querySelectorAll("video").forEach((video) => {
      video.pause();
      video.muted = true;
    });

    // Restore the header's z-index
    if (this.headerGroup) {
      this.headerGroup.style.zIndex = "501";
    }

    // Restore the announcement bar's z-index
    if (this.announcementBar) {
      this.announcementBar.style.zIndex = "4";
    }

    // Re-enable scrolling
    this.body.style.overflow = this.originalBodyOverflow;
  }

  listernerVideo(video) {
    video.addEventListener("ended", (e) => {
      this.currentIndex = parseInt(this.currentIndex) + 1;
      console.log(this.currentIndex, this.numberVideos);
      if (this.currentIndex >= this.numberVideos) {
        this.currentIndex = 0;
      }
      this.slider.go(this.currentIndex);
      console.log(`.video-${this.sectionId}-${this.currentIndex}`);
      this.video = this.querySelector(
        `.video-${this.sectionId}-${this.currentIndex}`
      );
      this.videos.forEach((video) => {
        video.pause();
        video.muted = true;
      });

      this.video.muted = false;
      this.video.play();
    });
  }
}
customElements.define("webstories-component", WebStories);
